<div class='sm:flex sm:items-start'>
  @if (_actionConfirmationData.destructiva !== false) {
  <div
    class='flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'>
    <svg class='h-6 w-6 text-red-600' fill='none' viewBox='0 0 24 24' stroke-width='1.5' stroke='currentColor'
         aria-hidden='true'>
      <path stroke-linecap='round' stroke-linejoin='round'
            d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z'/>
    </svg>
  </div>
  }
  <div class='ms-2 mt-3 text-center sm:mt-0 sm:text-left'>
    <div class='mt-2'>
      <p class='text-sm text-gray-500' [innerHTML]="_actionConfirmationData.mensaje"></p>
    </div>
  </div>
</div>
<div class='mt-5 sm:mt-4 sm:flex sm:flex-row-reverse'>
  <button type='button' (click)='confirm()'
          [class.bg-red-600]='_actionConfirmationData.destructiva !== false'
          [class.hover:bg-red-500]='_actionConfirmationData.destructiva !== false'
          [class.bg-gray-700]='_actionConfirmationData.destructiva === false'
          [class.hover:bg-gray-600]='_actionConfirmationData.destructiva === false'
          class='inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs sm:ml-3 sm:w-auto'>
    {{ (_actionConfirmationData.textoConfirmar ?? 'Confirmar') | translate }}
  </button>
  <button type='button' (click)='dismiss()' cdkFocusInitial
          class='mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto'>
    {{ (_actionConfirmationData.textoCancelar ?? 'Cancelar') | translate }}
  </button>
</div>


